import {
  alpha,
  Box,
  ButtonProps,
  TableCell,
  Typography,
  useTheme,
} from "@mui/material";
import { Flex } from "~/components/Flex";
import { LoadingButton } from "~/components/loading-button";
import { CompletionBar } from "~/components/Completion/CompletionBar";
import { useCanCloseCase } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/CloseCase";
import { useScope } from "~/hooks/useScope";
import { TrendingUpIcon } from "~/icons";

type CloseTicketButtonCellProps = {
  isLoading: boolean;
  isOpen: boolean;
  onClick: ButtonProps["onClick"];
  percentage: number;
};

export const TicketsCloseButtonCell = ({
  isLoading,
  isOpen,
  onClick,
  percentage,
}: CloseTicketButtonCellProps) => {
  const { spaceScope } = useScope();
  const theme = useTheme();
  const canCloseCase = useCanCloseCase(spaceScope);
  const isDisabled = !canCloseCase || !isOpen;

  return (
    <TableCell>
      <Flex
        flex="1 0 auto"
        justifyContent="flex-end"
        sx={{ pr: 3, display: "none" }}
        alignItems="center"
        className="closeCase"
        gap={1}
      >
        <Flex gap={1}>
          <TrendingUpIcon sx={{ color: "primary.main" }} />
          <Typography fontWeight={700}>{percentage}%</Typography>
        </Flex>
        <LoadingButton
          variant="outlined"
          loading={isLoading}
          color="primary"
          onClick={onClick}
          data-testid="close-ticket"
          buttonText={isOpen ? "Close Ticket" : "Closed"}
          sx={{
            background: (theme) =>
              !isDisabled
                ? alpha(theme.palette.primary.main, 0.2)
                : alpha(theme.palette.unknown.main, 0.2),
            borderColor: (theme) =>
              !isDisabled
                ? theme.palette.primary.main
                : theme.palette.text.disabled,
            color: isOpen ? "text.primary" : "text.disabled",
            whiteSpace: "nowrap",
          }}
          disabled={isDisabled}
        />
      </Flex>
      <Flex
        flex="1 0 auto"
        justifyContent="flex-end"
        sx={{ pr: 3 }}
        alignItems="center"
        className="progressBar"
        gap={1}
      >
        <Box width="176px">
          <CompletionBar
            {...{
              percent: percentage,
              height: theme.spacing(1),
              tooltip: `Progress: ${percentage}%`,
            }}
          />
        </Box>
      </Flex>
    </TableCell>
  );
};
